import { getAdminCategories, getAdminSliders } from '../lib/api';
import { getProducts } from './products';
import type { DashboardStats } from '../types/dashboard';

const LOW_STOCK_THRESHOLD = 5;

export async function getDashboardStats(): Promise<DashboardStats> {
  const [categories, products, sliders] = await Promise.all([
    getAdminCategories(),
    getProducts(),
    getAdminSliders(),
  ]);

  const activeProducts = products.filter((p) => p.is_active);
  const outOfStock = products.filter((p) => p.stock === 0).length;
  const lowStock = products.filter(
    (p) => p.is_active && p.stock > 0 && p.stock <= LOW_STOCK_THRESHOLD,
  ).length;

  const topCategories = [...categories]
    .sort((a, b) => (b.products_count ?? 0) - (a.products_count ?? 0))
    .slice(0, 5)
    .map((c) => ({
      id: c.id,
      name: c.name,
      products_count: c.products_count ?? 0,
    }));

  return {
    products: {
      total: products.length,
      active: activeProducts.length,
      inactive: products.length - activeProducts.length,
      outOfStock,
      lowStock,
      totalStock: products.reduce((sum, p) => sum + p.stock, 0),
    },
    categories: {
      total: categories.length,
      active: categories.filter((c) => c.is_active).length,
    },
    sliders: {
      total: sliders.length,
      active: sliders.filter((s) => s.is_active).length,
    },
    topCategories,
  };
}
